module.exports = __webpack_public_path__ + "promo/app-store-badges/google-play-store-fr-6ddfe180f55318d5dd902b3f5b056ea2.svg";


//////////////////
// WEBPACK FOOTER
// ./images/promo/app-store-badges/google-play-store-fr.svg
// module id = 1E7J
// module chunks = 21